import { render, staticRenderFns } from "./CreateEditCargoModal.vue?vue&type=template&id=596816d4&"
import script from "./CreateEditCargoModal.vue?vue&type=script&lang=js&"
export * from "./CreateEditCargoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports